

export default {
    $vuetify: {           
        save: 'Save',
        close: 'Close',
        cancel: 'Cancel',
        add: 'Add',
        remove: 'Remove',
        tryAgain: 'Try again',
        uploadError: 'Upload error...',
        dragImage: 'Drag your file(s) here to begin or click to browse',
        uploading: 'Uploading file...',
        dataIterator: {
            pageText: '{0}-{1} of {2}',
            noResultsText: 'No matching records found',
            loadingText: 'Loading items...',
        },
        dataTable: {
            name: 'Name',
            action: 'Action',
            edit: 'Edit',
            delete: 'Delete',
            itemsPerPageText: 'Rows per page:',
            ariaLabel: {
                sortDescending: ': Sorted descending. Activate to remove sorting.',
                sortAscending: ': Sorted ascending. Activate to sort descending.',
                sortNone: ': Not sorted. Activate to sort ascending.',
            },
            sortBy: 'Sort by',
        },
        dataFooter: {
            itemsPerPageText: 'Items per page:',
            itemsPerPageAll: 'All',
            nextPage: 'Next page',
            prevPage: 'Previous page',
            firstPage: 'First page',
            lastPage: 'Last page',
        },
        datePicker: {
            itemsSelected: '{0} selected',
        },
        noDataText: 'No data available',
        carousel: {
            prev: 'Previous visual',
            next: 'Next visual',
        },
        calendar: {
            moreEvents: '{0} more',
        },
        fileInput: {
            counter: '{0} files',
            counterSize: '{0} files ({1} in total)',
        },
        rules: {
            required: 'Field is required',
            email: 'Field must be a valid email',
            name: 'Field must be less than 100 characters',
            number: 'Field must be a valid number',
        },
        drawer: {
            dashboard: "Dashboard",
            customer: "Customers",
            department: "Departments",
            collection: "Categories",
            product: "Products",
            order: "Orders",
            editProfile: "Edit Profile",
            logout: "Logout",
            login: "Login"
        },
        dialog: {
            close: "Close",
            success: "Sucess!",
            warning: "Caution!",
            info: "Caution!",
            error: "Error!",
            no: "No",
            yes: "Yes"
        },       
        login: {
            forgotPassword: "Forgot your password?",
            name: "Login",
            password: "Password"
        },        
        department: {
            deleteQuestion: "Confirm deletion of department?",
            name: 'Name',
            actived: 'Actived',
            info: 'Data',                
        },
        collection: {
            deleteQuestion: "Confirm deletion of category?",
            addProducts: 'Start adding products to your collection',
            products: 'Collection\'s products',
            info: 'Data',
            name: 'Name',
            actived: 'Actived',
            department: 'Department',
            nonRequiredDeparment: 'Department is not required'                    
        },
        product: {
            deleteQuestion: "Confirm deletion of product?",
            price: 'Price',
            weight: 'Weight',
            name: 'Name',
            image: 'Pictures',
            description: 'Description',
            actived: 'Actived',
            info: 'Data',
        },
        // order: {
        //     deleteQuestion: "Confirm deletion of order?",
        //     info: 'Data',
        //     customer: 'Customer',

        // }       
    }
}